module.exports = ".see-more {\n  padding: 10px 20px;\n  text-align: right; }\n"